/* START GENAI@GHCOPILOT */
export const alpha_locale_safe = /(?![-/.&#*+@|?!%$^()=<>,'\\:;])[\p{N}\p{P}\p{S}]/gu;

export const alphanumeric_locale_safe = /[\w\-/.&#*+@|?!%$^()=<>,'\\:;]/;

/* END GENAI@GHCOPILOT */
